import React from "react";

import { View, StyleSheet } from "react-native";
import { ActivityIndicator, useTheme } from "react-native-paper";

function Processing() {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.surface} />
    </View>
  );
}

export { Processing };

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: "#33333355",
    justifyContent: "center",
    alignItems: "center",
  },
});
